export default "__VITE_ASSET__MBzWQDjx__"